import { qs } from '../routing'

export const tokenGenerator = (id: string): { Authorization: string } => {
  const token = qs(document.location.search, 'token')

  return { Authorization: `${id}:${token}` }
}
